<template>
  <div class="row kft-product-full-details__map-and-icons mt-13 mt-md-8">
    <TapToRemoveOverlay>
      <div
        v-show="eventGetters.getAttendanceMode(kftEvent) !== 'ONLINE'"
        class="col-12 kft-product-full-details__map-and-icons__map"
      >
        <div style="height: 275px">
          <ClientOnly fallback-tag="span" fallback="Loading location map...">
            <l-map
              ref="map"
              :use-global-leaflet="false"
              :zoom="16"
              :center="coordinates"
            >
              <l-tile-layer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                layer-type="base"
                name="OpenStreetMap"
              ></l-tile-layer>
              <l-marker :draggable="false" :lat-lng="coordinates" />
            </l-map>
          </ClientOnly>
        </div>
      </div>
    </TapToRemoveOverlay>

    <LocationInfo
      :title="getTitleByCategory('location', kftEvent)"
      :subtitle="`${eventGetters.getTitle(kftEvent)} - ${
        eventGetters.getAttendanceMode(kftEvent) === 'ONLINE'
          ? $t('general.online')
          : eventGetters.getFormattedAddress(kftEvent)
      }`"
      class="col-12 d-flex kft-product-full-details__map-and-icons__icon mt-5"
    />
  </div>
</template>

<script lang="ts">
import 'leaflet/dist/leaflet.css'
import { LMap, LTileLayer, LMarker } from '@vue-leaflet/vue-leaflet'
import { useTitleByCategory } from '~/composables/product/useGetTitleByCategory'

export default {
  name: 'LocationAndMap',
  components: {
    LMap,
    LMarker,
    LTileLayer,
  },

  props: {
    kftEvent: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  setup(props) {
    const { getTitleByCategory } = useTitleByCategory()

    const coordinates = computed(() => {
      const latLng = eventGetters.getCoordinates(props.kftEvent)

      return {
        lat: latLng?.[0] || 0,
        lng: latLng?.[1] || 0,
      }
    })
    return {
      coordinates,
      getTitleByCategory,
    }
  },
}
</script>

<style lang="postcss" scoped>
.kft-location-info {
  margin: 0;
}
.kft-product-full-details__map-and-icons__map {
  z-index: 1;
  &:deep(.leaflet-pane) {
    z-index: 0;
  }
  &:deep(.leaflet-bottom),
  &:deep(.leaflet-top) {
    z-index: 1;
  }
}
</style>
